import React from "react";

import Section from "../components/Section";
import { EnvContext } from "../context/env-context";
import ParseBoxTypes from "../utilities/parseBoxTypes";

class SiteStart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      data: {},
      lang: document.documentElement.lang.split("-")[0],
    };
  }

  componentDidMount() {
    if(window.pageData?.content){
      this.setState({
        isLoaded: true,
        data: window.pageData,
      });
    }
    else{  
      let url = null,
          headers = {};
      if (this.context === "local") {
        url = "/memberpage.json";
        headers = {
          Authorization: `Basic ${btoa("staging:*Staging21%")}`,
        };
      } else if (this.context === "staging") {
        url = "https://staging.puregym.swiss/wp-json/memberpage/v1/info/";
        headers = {
          Authorization: `Basic ${btoa("staging:*Staging21%")}`,
        };
      } else if (this.context === "production") {
        url = "/memberpage.json";
        headers = {
          Authorization: `Basic ${btoa("staging:*Staging21%")}`,
        };
      }

      if (url) {
        fetch(url, {
          headers,
          mode: "cors",
        })
          .then((res) => res.json())
          .then(
            (result) => {
              console.log("Geladene Daten:", result);
              this.setState({
                isLoaded: true,
                data: result,
              });
            },
            (error) => {
              this.setState({
                isLoaded: false,
                error,
              });
            }
          );
      }
    }
  }

  render() {
    const { isLoaded, data, lang } = this.state;
    return (
      <>
        {isLoaded && Array.isArray(data.content) && data.content.length > 0 ? (
          data.content.map((row, i) => (
            <Section className={ i != 0 ?"tw-p-5 tw-pb-0 tw-max-w-screen-lg tw-m-auto md:tw-py-5 tw-overflow-hidden" : "tw-overflow-hidden"} key={i}> 
              {Array.isArray(row.element) ? row.element.map((el, elIndex) => (
                <ParseBoxTypes key={elIndex} el={el} lang={lang} prices={data.startpage_prices}/>
              )) : <p></p>}
            </Section>
          ))
        ) : (
          <div></div>
        )}
      </>
    );
  }
  
}
SiteStart.contextType = EnvContext;

export default SiteStart;
